import * as MAction from './menu.actionTypes';
import { Dispatch } from 'react';
import BoardService from '../services/board.service';

const boardSevice = new BoardService();

export const getMenuPermissions = () => async(dispatch: Dispatch<MAction.MenuActionTypes>, getState: any) => {
    try {
        const {boardDetails} = getState();
        const params = { tagId: boardDetails.tagId, teamId: boardDetails.teamId };
        const resp = await boardSevice.getBoardMenu(params);
        const permissions = resp.data.topMenuDetails || {};
        dispatch({
            type: MAction.GET_MENU_PERMISSION,
            permissions
        });
    }
    catch(e) {

    }
}

export const updateMenuPermissions = (permissions: any) => async(dispatch: Dispatch<MAction.MenuActionTypes>, getState: any) => {
    try {
        dispatch({
            type: MAction.UPDATE_MENU_PERMISSION,
            permissions
        });
    }
    catch(e) {

    }
}

export const changeMenuBoardTheme = (theme: any) => (dispatch: Dispatch<MAction.MenuActionTypes>) => {
    dispatch({
        type: MAction.CHANGE_MENU_BOARD_THEME,
        theme
    });
}

export const changeMenuBoardColumnHeader = (columnId: string, color: string) => (dispatch: Dispatch<MAction.MenuActionTypes>) => {
    dispatch({
        type: MAction.CHANGE_MENU_BOARD_COUMN_HEADER,
        columnId,
        color
    });
}

export const changeBoardState =  (actionType: string, payload: any) => (dispatch: Dispatch<MAction.MenuActionTypes>, getState: any) => {
    const {boardDetails} = getState();
    const {boardType} = boardDetails;
    dispatch({
        type: MAction.CHANGE_MENU_BOARD_STATE,
        actionType,
        columns: payload.columns,
        theme: payload.theme,
        boardType,
        appyToAllWs: payload.appyToAllWs
    });
}

export const boardUpdateSharedMembers = (data: any) => (dispatch: Dispatch<MAction.MenuActionTypes>) => {
        dispatch({
            type: MAction.BOARD_UPDATE_SHARED_MEMBERS,
            data
        });
}